var prisma = prisma || {};
(function ($) {

    /* Caminhos da aplicação *****************************************/

    //Caminho raiz atual da aplicação (incluindo diretório virtual se existir).
    prisma.appPath = prisma.appPath || '/';

    prisma.pageLoadTime = new Date();

    //Converte o caminho fornecido para caminho absoluto usando a variável prisma.appPath.
    prisma.toAbsAppPath = function (path) {
        if (path.indexOf('/') == 0) {
            path = path.substring(1);
        }

        return prisma.appPath + path;
    };

    /* AUTORIZAÇÃO **********************************************/
    //Implementa API de Autorização que simplifica o uso de scripts de autorização gerados pelo prisma.

    prisma.auth = prisma.auth || {};

    prisma.auth.todasPermissoes = prisma.auth.todasPermissoes || {};

    prisma.auth.permissoesConcedidas = prisma.auth.permissoesConcedidas || {};

    //Deprecated. Em vez disso, usar prisma.auth.isGranted.
    prisma.auth.hasPermissao = function (nomePermissao) {
        return prisma.auth.isGranted.apply(this, arguments);
    };

    //Deprecated. Em vez disso, usar prisma.auth.isAnyGranted.
    prisma.auth.hasAnyOfPermissoes = function () {
        return prisma.auth.isAnyGranted.apply(this, arguments);
    };

    //Deprecated. Em vez disso, usar prisma.auth.areAllGranted.
    prisma.auth.hasAllOfPermissoes = function () {
        return prisma.auth.areAllGranted.apply(this, arguments);
    };

    prisma.auth.isGranted = function (nomePermissao) {
        return prisma.auth.todasPermissoes[nomePermissao] != undefined && prisma.auth.permissoesConcedidas[nomePermissao] != undefined;
    };

    prisma.auth.isAnyGranted = function () {
        if (!arguments || arguments.length <= 0) {
            return true;
        }

        for (var i = 0; i < arguments.length; i++) {
            if (prisma.auth.isGranted(arguments[i])) {
                return true;
            }
        }

        return false;
    };

    prisma.auth.areAllGranted = function () {
        if (!arguments || arguments.length <= 0) {
            return true;
        }

        for (var i = 0; i < arguments.length; i++) {
            if (!prisma.auth.isGranted(arguments[i])) {
                return false;
            }
        }

        return true;
    };

    /* CONFIGURAÇÕES **************************************************/
    //Implementa API de Configuração que simplifica o uso de scripts de configuração gerados pelo prisma.

    prisma.configuracao = prisma.configuracao || {};

    prisma.configuracao.valores = prisma.configuracao.valores || {};

    prisma.configuracao.get = function (name) {
        return prisma.configuracao.valores[name];
    };

    prisma.configuracao.getBoolean = function (name) {
        var value = prisma.configuracao.get(name);
        return value == 'true' || value == 'True';
    };

    prisma.configuracao.getInt = function (name) {
        return parseInt(prisma.configuracao.values[name]);
    };

    /* LOGGING ***************************************************/
    //Implementa API de Loggin que fornece segurança e uso controlado de console.log.

    prisma.log = prisma.log || {};

    prisma.log.levels = {
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        FATAL: 5
    };

    prisma.log.level = prisma.log.levels.DEBUG;

    prisma.log.log = function (logObject, logLevel) {
        if (!window.console || !window.console.log) {
            return;
        }

        if (logLevel != undefined && logLevel < prisma.log.level) {
            return;
        }

        console.log(logObject);
    };

    prisma.log.debug = function (logObject) {
        prisma.log.log("DEBUG: ", prisma.log.levels.DEBUG);
        prisma.log.log(logObject, prisma.log.levels.DEBUG);
    };

    prisma.log.info = function (logObject) {
        prisma.log.log("INFO: ", prisma.log.levels.INFO);
        prisma.log.log(logObject, prisma.log.levels.INFO);
    };

    prisma.log.warn = function (logObject) {
        prisma.log.log("WARN: ", prisma.log.levels.WARN);
        prisma.log.log(logObject, prisma.log.levels.WARN);
    };

    prisma.log.error = function (logObject) {
        prisma.log.log("ERROR: ", prisma.log.levels.ERROR);
        prisma.log.log(logObject, prisma.log.levels.ERROR);
    };

    prisma.log.fatal = function (logObject) {
        prisma.log.log("FATAL: ", prisma.log.levels.FATAL);
        prisma.log.log(logObject, prisma.log.levels.FATAL);
    };

    /* MENSAGEM **************************************************/
    //Define API de Mensagem, não implementa.

    prisma.message = prisma.message || {};

    var showMessage = function (message, title) {
        alert((title || '') + ' ' + message);

        if (!$) {
            prisma.log.warn('prisma.message não pode retornar já que jQuery não está definido!');
            return null;
        }

        return $.Deferred(function ($dfd) {
            $dfd.resolve();
        });
    };

    prisma.message.info = function (message, title) {
        prisma.log.warn('prisma.message.info não está implementado!');
        return showMessage(message, title);
    };

    prisma.message.success = function (message, title) {
        prisma.log.warn('prisma.message.success não está implementado!');
        return showMessage(message, title);
    };

    prisma.message.warn = function (message, title) {
        prisma.log.warn('prisma.message.warn não está implementado!');
        return showMessage(message, title);
    };

    prisma.message.error = function (message, title) {
        prisma.log.warn('prisma.message.error não está implementado!');
        return showMessage(message, title);
    };

    prisma.message.confirm = function (message, titleOrCallback, callback) {
        prisma.log.warn('prisma.message.confirm não está implementado!');

        if (titleOrCallback && !(typeof titleOrCallback == 'string')) {
            callback = titleOrCallback;
        }

        var result = confirm(message);
        callback && callback(result);

        if (!$) {
            prisma.log.warn('prisma.message não pode retornar já que jQuery não está definido!');
            return null;
        }

        return $.Deferred(function ($dfd) {
            $dfd.resolve();
        });
    };

    /* UI *******************************************************/

    prisma.ui = prisma.ui || {};

    /* UI BLOCK */
    //Define API de UI Block, não implementa.

    prisma.ui.block = function (elm) {
        prisma.log.warn('prisma.ui.block não está implementado!');
    };

    prisma.ui.unblock = function (elm) {
        prisma.log.warn('prisma.ui.unblock não está implementado!');
    };

    /* UI BUSY */
    //Define API de UI Busy, não implementa.

    prisma.ui.setBusy = function (elm, optionsOrPromise) {
        prisma.log.warn('prisma.ui.setBusy não está implementado!');
    };

    prisma.ui.clearBusy = function (elm) {
        prisma.log.warn('prisma.ui.clearBusy não está implementado!');
    };

    /* EVENT BUS SIMPLES *****************************************/

    prisma.event = (function () {

        var _callbacks = {};

        var on = function (eventName, callback) {
            if (!_callbacks[eventName]) {
                _callbacks[eventName] = [];
            }

            _callbacks[eventName].push(callback);
        };

        var off = function (eventName, callback) {
            var callbacks = _callbacks[eventName];
            if (!callbacks) {
                return;
            }

            var index = -1;
            for (var i = 0; i < callbacks.length; i++) {
                if (callbacks[i] === callback) {
                    index = i;
                    break;
                }
            }

            if (index < 0) {
                return;
            }

            _callbacks[eventName].splice(index, 1);
        };

        var trigger = function (eventName) {
            var callbacks = _callbacks[eventName];
            if (!callbacks || !callbacks.length) {
                return;
            }

            var args = Array.prototype.slice.call(arguments, 1);
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i].apply(this, args);
            }
        };

        // Interface pública ///////////////////////////////////////////////////

        return {
            on: on,
            off: off,
            trigger: trigger
        };
    })();


    /* UTILS ***************************************************/

    prisma.utils = prisma.utils || {};

    /* Cria um nome de namespace.
    *  Exemplo:
    *  var taskService = prisma.utils.createNamespace(prisma, 'services.task');
    *  taskService será igual a prisma.services.task
    *  primeiro argumento (root) deve estar definido
    ************************************************************/
    prisma.utils.createNamespace = function (root, ns) {
        var parts = ns.split('.');
        for (var i = 0; i < parts.length; i++) {
            if (typeof root[parts[i]] == 'undefined') {
                root[parts[i]] = {};
            }

            root = root[parts[i]];
        }

        return root;
    };

    /* Busca e substitui uma string (search) por outra string (replacemente) na
    *  string fornecida(str).
    *  Exemplo:
    *  prisma.utils.replaceAll('String de teste', 'de', 'X') = 'String de XsX'
    ************************************************************/
    prisma.utils.replaceAll = function (str, search, replacement) {
        var fix = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return str.replace(new RegExp(fix, 'g'), replacement);
    };

    /* Formata uma string assim como string.format no C#.
    *  Exemplo:
    *  prisma.utils.formatString('Olá {0}','Denis') = 'Olá Denis'
    ************************************************************/
    prisma.utils.formatString = function () {
        if (arguments.length < 1) {
            return null;
        }

        var str = arguments[0];

        for (var i = 1; i < arguments.length; i++) {
            var placeHolder = '{' + (i - 1) + '}';
            str = prisma.utils.replaceAll(str, placeHolder, arguments[i]);
        }

        return str;
    };

    prisma.utils.toPascalCase = function (str) {
        if (!str || !str.length) {
            return str;
        }

        if (str.length === 1) {
            return str.charAt(0).toUpperCase();
        }

        return str.charAt(0).toUpperCase() + str.substr(1);
    }

    prisma.utils.toCamelCase = function (str) {
        if (!str || !str.length) {
            return str;
        }

        if (str.length === 1) {
            return str.charAt(0).toLowerCase();
        }

        return str.charAt(0).toLowerCase() + str.substr(1);
    }

    prisma.utils.truncateString = function (str, maxLength) {
        if (!str || !str.length || str.length <= maxLength) {
            return str;
        }

        return str.substr(0, maxLength);
    };

    prisma.utils.truncateStringWithPostfix = function (str, maxLength, postfix) {
        postfix = postfix || '...';

        if (!str || !str.length || str.length <= maxLength) {
            return str;
        }

        if (maxLength <= postfix.length) {
            return postfix.substr(0, maxLength);
        }

        return str.substr(0, maxLength - postfix.length) + postfix;
    };

    prisma.utils.isFunction = function (obj) {
        if ($) {
            //Preferível usar jQuery se possível
            return $.isFunction(obj);
        }

        //alternativa para $.isFunction
        return !!(obj && obj.constructor && obj.call && obj.apply);
    };

    /**
     * parameterInfos deve ser um array de objetos { name, value }
     * one name é um nome de parâmetro string e value é seu valor.
     * includeQuestionMark é true por padrão.
     */
    prisma.utils.buildQueryString = function (parameterInfos, includeQuestionMark) {
        if (includeQuestionMark === undefined) {
            includeQuestionMark = true;
        }

        var qs = '';

        for (var i = 0; i < parameterInfos.length; ++i) {
            var parameterInfo = parameterInfos[i];
            if (parameterInfo.value === undefined) {
                continue;
            }

            if (parameterInfo.value === null) {
                parameterInfo.value = '';
            }

            if (!qs.length) {
                if (includeQuestionMark) {
                    qs = qs + '?';
                }
            } else {
                qs = qs + '&';
            }

            if (parameterInfo.value.toJSON && typeof parameterInfo.value.toJSON === "function") {
                qs = qs + parameterInfo.name + '=' + encodeURIComponent(parameterInfo.value.toJSON());
            } else {
                qs = qs + parameterInfo.name + '=' + encodeURIComponent(parameterInfo.value);
            }
        }

        return qs;
    }

    /**
     * Seta um valor de cookie para a chave fornecida.
     * @param {string} key
     * @param {string} value 
     * @param {Date} expireDate Optional data de expiração (padrão: 30 dias).
     */
    prisma.utils.setCookieValue = function (key, value, expireDate) {
        if (!expireDate) {
            expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 30);
        }

        document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + "; expires=" + expireDate.toUTCString();
    };

    /**
     * Obtém um cookir pela chave.
     * @param {string} key
     * @returns {string} valor do cookie
     */
    prisma.utils.getCookieValue = function (key) {
        var equalities = document.cookie.split('; ');
        for (var i = 0; i < equalities.length; i++) {
            if (!equalities[i]) {
                continue;
            }

            var splitted = equalities[i].split('=');
            if (splitted.length != 2) {
                continue;
            }

            if (decodeURIComponent(splitted[0]) === key) {
                return decodeURIComponent(splitted[1] || '');
            }
        }

        return null;
    };

    /* TIMING *****************************************/
    prisma.timing = prisma.timing || {};

    prisma.timing.utcClockProvider = (function () {

        var toUtc = function (date) {
            return Date.UTC(
                date.getUTCFullYear()
                , date.getUTCMonth()
                , date.getUTCDate()
                , date.getUTCHours()
                , date.getUTCMinutes()
                , date.getUTCSeconds()
                , date.getUTCMilliseconds()
            );
        }

        var now = function () {
            return new Date();
        };

        var normalize = function (date) {
            if (!date) {
                return date;
            }

            return new Date(toUtc(date));
        };

        // Interface pública ///////////////////////////////////////////////////

        return {
            now: now,
            normalize: normalize
        };
    })();

    prisma.timing.localClockProvider = (function () {

        var toLocal = function (date) {
            return new Date(
                date.getFullYear()
                , date.getMonth()
                , date.getDate()
                , date.getHours()
                , date.getMinutes()
                , date.getSeconds()
                , date.getMilliseconds()
            );
        }

        var now = function () {
            return toLocal(new Date());
        }

        var normalize = function (date) {
            if (!date) {
                return date;
            }

            return toLocal(date);
        }

        // Interface pública ///////////////////////////////////////////////////

        return {
            now: now,
            normalize: normalize
        };
    })();

    prisma.timing.unspecifiedClockProvider = (function () {

        var now = function () {
            return new Date();
        }

        var normalize = function (date) {
            return date;
        }

        // Interface pública ///////////////////////////////////////////////////

        return {
            now: now,
            normalize: normalize
        };
    })();

    prisma.timing.convertToUserTimezone = function (date) {
        var localTime = date.getTime();
        var utcTime = localTime + (date.getTimezoneOffset() * 60000);
        var targetTime = parseInt(utcTime) + parseInt(prisma.timing.timeZoneInfo.windows.currentUtcOffsetInMilliseconds);
        return new Date(targetTime);
    };

    /* CLOCK *****************************************/
    prisma.clock = prisma.clock || {};

    prisma.clock.now = function () {
        if (prisma.clock.provider) {
            return prisma.clock.provider.now();
        }

        return new Date();
    }

    prisma.clock.normalize = function (date) {
        if (prisma.clock.provider) {
            return prisma.clock.provider.normalize(date);
        }

        return date;
    }

    prisma.clock.provider = prisma.timing.unspecifiedClockProvider;

    /* SEGURANÇA ***************************************/
    prisma.security = prisma.security || {};
    prisma.security.antiForgery = prisma.security.antiForgery || {};

    prisma.security.antiForgery.tokenCookieName = 'XSRF-TOKEN';
    prisma.security.antiForgery.tokenHeaderName = 'X-XSRF-TOKEN';

    prisma.security.antiForgery.getToken = function () {
        return prisma.utils.getCookieValue(prisma.security.antiForgery.tokenCookieName);
    };

})(jQuery);